import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SPaymentDetailsPageContentButtons = styled.div`
  margin-top: 20px;
  gap: 16px;

  ${setFlexDF};
`;
